import React, { Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import { Card } from 'reactstrap'

import { useAppSelector } from '../../../hooks/redux'
import FalconCardHeader from '../../../components/common/FalconCardHeader'
import ButtonIcon from '../../../components/common/ButtonIcon'

interface AuthedUser {
    uid?: string
    superAdmin?: boolean
}

interface TableCardProps {
    toggleModal: () => void
    title: string
    buttonText?: string
    children?: React.ReactNode
}

/**
 * Card wrapper with header actions for table views in the super-admin panel.
 */
const TableCard = ({
    toggleModal,
    title,
    buttonText,
    children,
}: TableCardProps) => {
    const authedUser = useAppSelector(state => state.auth.user) as AuthedUser | null
    const { t } = useTranslation()

    return (
        <Card className='mb-3'>
            <FalconCardHeader title={title} light={false}>
                <Fragment>
                    {authedUser?.superAdmin &&
                        <ButtonIcon
                            icon='plus'
                            transform='shrink-3 down-2'
                            color='danger'
                            size='sm'
                            onClick={() => toggleModal()}
                        >
                            {buttonText}
                        </ButtonIcon>
                    }
                    <ButtonIcon
                        icon='filter'
                        transform='shrink-3 down-2'
                        color='falcon-default'
                        size='sm'
                        className='mx-2'
                    >
                        {t('filter')}
                    </ButtonIcon>
                </Fragment>
            </FalconCardHeader>
            {children}
        </Card>
    )
}

export default TableCard
